<template>
  <v-autocomplete
    v-bind="$attrs"
    color="green"
    no-data-text="Нет данных"
    auto-select-first
    :append-outer-icon="clearable ? 'mdi-close' : ''"
    @click:append-outer="$emit('input', 0)"
    @change="e => $emit('input', e)"
  ></v-autocomplete>
</template>

<script>
export default {
  props: {
    clearable: Boolean
  }
}
</script>